// extracted by mini-css-extract-plugin
export default {"standardButton":"ButtonStyles_standardButton__NKCTQ","drawingButton":"ButtonStyles_drawingButton__X9nG5"};